module.exports = __webpack_public_path__ + "static/media/sss-auto-parking-selected.e5f6feff.svg";